import { useEffect, useState } from "react";

const useSlotCountUp = (end, duration = 1800) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const startTime = performance.now();

    const animate = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);

      
      const eased = 1 - Math.pow(1 - progress, 3);

      const current = Math.floor(eased * end);

      setValue(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setValue(end);
      }
    };

    requestAnimationFrame(animate);
  }, [end]);

  return value;
};

export default useSlotCountUp;